import { t } from 'i18next';
import React from 'react';

import { TYPOGRAPHY } from 'Components/foundation';
import UButton from 'Components/unit/UButton/UButton';
import UDatePicker from 'Components/unit/UDatePicker/UDatePicker';

import styles from './ExportCard.style';

type ReportCardProps = {
  title: string;
  subtitle: string;
  onDownload: (from: Date, to: Date) => void;
};

export const ExportCard: React.FC<ReportCardProps> = ({ title, subtitle, onDownload }) => {
  const [startDate, setStartDate] = React.useState<Date>(new Date());
  const [endDate, setEndDate] = React.useState<Date>(new Date());

  const handleDownload = () => {
    onDownload(startDate, endDate);
  };

  return (
    <div style={styles.cardWrapper}>
      <div style={{ textAlign: 'center' }}>
        <p style={{ ...TYPOGRAPHY.BODY2_SEMIBOLD }}> {title}</p>
        <p style={{ ...TYPOGRAPHY.BODY3 }}>{subtitle}</p>
      </div>
      <div style={styles.dateWrapper}>
        <div style={styles.dateLabel}>{t('analytics:reports.from')} : </div>
        <UDatePicker
          style={styles.dateInput}
          date={startDate}
          onClick={(date: Date) => {
            setStartDate(date);
          }}
        />
      </div>
      <div style={styles.dateWrapper}>
        <div style={styles.dateLabel}>{t('analytics:reports.to')} : </div>
        <UDatePicker
          style={styles.dateInput}
          date={endDate}
          onClick={(date: Date) => {
            setEndDate(date);
          }}
        />
      </div>
      <UButton type="accentuated" text={t('analytics:reports.download')} onClick={handleDownload} />
    </div>
  );
};
